import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataPreferredContactMethodsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataPreferredContactMethodsReducer.preferredContactMethodsFeatureKey]
);

export const getStaticDataPreferredContactMethodsFailure = createSelector(
  getStaticDataPreferredContactMethodsState,
  staticDataCountriesReducer.fromStaticDataPreferredContactMethodsReducer.getPreferredContactMethodsFailure
);

export const getStaticDataPreferredContactMethodsResponse = createSelector(
  getStaticDataPreferredContactMethodsState,
  staticDataCountriesReducer.fromStaticDataPreferredContactMethodsReducer.getPreferredContactMethodsResponse
);

export const getStaticDataPreferredContactMethodsIsLoaded = createSelector(
  getStaticDataPreferredContactMethodsState,
  staticDataCountriesReducer.fromStaticDataPreferredContactMethodsReducer.getPreferredContactMethodsIsLoaded
);
